import {until} from 'lit-html/directives/until';
import {formLabels} from '@modules/i18n-labels';
import {exceptionCodes, pages} from '@modules/constants-enumerate';
import {routerInstance} from '@aofl/router';
import SessionActions from '@modules/session-sdo';

const renderErrors = (ctx, html) => {
  if (!ctx.errorCode) {
    return '';
  }

  let message;
  if (!ctx.form.code.isRequired.valid) {
    message = formLabels.required;
  }

  if (ctx.errorCode === exceptionCodes.INPUT_INVALID_REDEEM_CODE) {
    message = ctx.__('<tt-dlu7GbL9>', 'The code you entered is not valid. Please check your code and try again.');
  }

  if (ctx.errorCode === exceptionCodes.LOGIC_GENERAL) {
    message = ctx.__('<tt-F9z0JAB3>', 'Looks like you already have the maximum number of children in your ABC&ZeroWidthSpace;mouse Aprende Inglés account. You cannot add a new child.');
  }

  if (ctx.errorCode === 114109) {
    message = ctx.__('<tt-8qD+Z4TQ>', 'Your redeem code has expired.');
  }

  if (ctx.errorCode === 114112) {
    message = ctx.__('<tt-9C8o0NP8>', 'This code has already been redeemed and is connected to an existing family account. Log in to your account to sync any new products assigned to your child.');
    if (!ctx.loggedIn) {
      message.then((val) => {
        setTimeout(() => {
          SessionActions.logout().then(() => {
            routerInstance.navigate(pages.HOME + '?message=' + encodeURI(val.strings[0]), {});
          });
        }, 150); /** @todo temporary hack - wait for drawer to close */
      });
    }
  }

  return html`
    <div class="is-invalid">
      <p class="invalid-feedback m-0 d-block">
        ${until(message)}
      </p>
    </div>`;
};
const getLabel = (ctx) => {
  if (ctx.forLoggedInParent) {
    return ctx.__('<tt-nwqBG93c>', 'Please enter your access code');
  }
  return ctx.__('<tt-4IG6KxES>', 'Please enter your redeem code');
};

const getBtnLabel = (ctx) => {
  if (ctx.forLoggedInParent) {
    return ctx.__('<tt-GTs4PWFt>', 'Redeem');
  }
  return formLabels.submit;
};

export default (ctx, html) => html`
  <form @submit="${ctx.submit}" novalidate autocomplete="on" method="post" class="pb-3">
    <div class="form-group">
      <label for="code">${until(getLabel(ctx))}</label>
      <input
        id="code"
        name="code"
        value="${ctx.code}"
        type="text"
        placeholder=""
        class="form-control form-control-sm ${!ctx.form.code.valid ? 'is-invalid' : ''}"
        @input="${ctx.updateCode}"
        @blur="${ctx.updateCode}">
      ${renderErrors(ctx, html)}
    </div>
    <button
      type="submit"
      data-bi-id="submit_redeem_code"
      ?disabled="${ctx.submitting || !ctx.form.observed}"
      class="btn btn-primary btn-block btn-lg btn-pill btn-submit mx-auto  mt-3 ${ctx.submitting ? 'disabled' : ''}">${until(formLabels.submit)}</button>
  </form>
`;
